import React from 'react'
import { StyleSheet } from 'react-native'
import { v4 as uuidv4 } from 'uuid'

import { Avatar } from 'widgets/Avatar'
import { Box } from 'widgets/Box'
import { Image } from 'widgets/Image'
import { Text } from 'widgets/Text'

import { useMaxWidth } from 'hooks/useMaxWidth'

import { defaultPostThumbnailUrl } from 'utils/media'
import commonStyles from 'utils/styles/commonStyles'

type CoachReferralViewProps = {
  data: any
}

export const CoachReferralView = ({ data }: CoachReferralViewProps) => {
  const maxWidth = useMaxWidth()
  const avatarSize = maxWidth.width * 0.35

  const { user, group, members, workouts } = data

  const styles = StyleSheet.create({
    mh500: {
      maxHeight: 500,
    },
    avatarBorder: {
      borderRadius: avatarSize / 2,
    },
  })

  return (
    <Box align='center' margin={{ horizontal: 'md' }}>
      <Box
        margin={{ top: 'md' }}
        justifyContent='center'
        align='center'
        width='100%'
        height={maxWidth.width * 0.9}
        style={styles.mh500}
      >
        <Box flex={1} align='center' justifyContent='center'>
          <Box
            width={avatarSize + 2}
            height={avatarSize + 2}
            backgroundColor='greyDarkest'
            align='center'
            justifyContent='center'
            style={styles.avatarBorder}
            border={{ width: 1, color: 'v2midGrey' }}
          >
            <Avatar width={avatarSize} height={avatarSize} image={user?.avatar} />
          </Box>
          <Box margin={{ top: 'smd' }}>
            <Text bold fontSize='sm' color='white'>
              {`${user?.username} `}
              <Text fontSize='sm' color='white'>
                invited you to join
              </Text>
            </Text>
          </Box>
        </Box>

        <Box
          width='100%'
          pointerEvents='box-none'
          flexDirection='row'
          align='center'
          justifyContent='space-between'
          margin={{ bottom: 'xl' }}
        >
          <Box flex={1} backgroundColor='v2black' borderRadius='smd' padding='sm'>
            <Box flexDirection='row'>
              <Box
                width={60}
                height={60}
                borderRadius='sm'
                backgroundColor='greyDarker'
                style={commonStyles.overflowHidden}
              >
                <Box
                  position='absolute'
                  display='flex'
                  width='100%'
                  height='100%'
                  backgroundColor='greyLight'
                >
                  <Image
                    cacheKey={
                      group
                        ? // eslint-disable-next-line no-underscore-dangle
                          `${group?.id}-group-cover-${group?.cover?._original?.etag}-large`
                        : uuidv4()
                    }
                    resizeMode='cover'
                    style={commonStyles.fullSize}
                    source={{ uri: group?.cover?.url || defaultPostThumbnailUrl }}
                  />
                </Box>
              </Box>
              <Box flex={1} margin={{ horizontal: 'sm' }} justifyContent='center'>
                <Text bold color='white' numberOfLines={1}>
                  {group?.title}
                </Text>
                <Text color='greyLight' fontSize='sm'>
                  {user?.username}
                </Text>
              </Box>
            </Box>

            <Box margin={{ top: 'sm' }} height={40} flexDirection='row'>
              <Box
                flex={1}
                align='center'
                justifyContent='center'
                borderRadius='sm'
                backgroundColor='greyDarker'
              >
                <Text bold align='center' color='white' fontSize='sm'>
                  {members?.length && `${members?.length} `}
                  <Text color='white' fontSize='sm'>
                    Member{members?.length !== 1 && 's'}
                  </Text>
                </Text>
              </Box>
              <Box margin='xs' />
              <Box
                flex={1}
                align='center'
                justifyContent='center'
                borderRadius='sm'
                backgroundColor='greyDarker'
              >
                <Text bold align='center' color='white' fontSize='sm'>
                  {workouts?.length && `${workouts?.length > 99 ? '99+' : workouts?.length} `}
                  <Text color='white' fontSize='sm'>
                    Post{workouts?.length !== 1 && 's'}
                  </Text>
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
